import { Button } from '@visikon/spine';
import { Tokens } from '@visikon/spine/src/styles/tokens';
import { NavigationIcon } from '../../images/icons';
import { useIsEmbedded } from '../../reducers/resourcesReducer';
import { useSelfServiceIsEditMode } from '../../screens/embeddedMessageScript/EmbeddedMessageScript';
import { IconWrapper } from './MoveButton';

type Props = {
  id?: string;
  contentType: string;
};

export const AddButton = (p: Props) => {
  const onClick = () => {
    window.parent.postMessage({ type: p.contentType, action: 'add' }, '*');
  };

  const isEmbedded = useIsEmbedded();
  const isEditMode = useSelfServiceIsEditMode();

  if (!isEmbedded || !isEditMode) return null;

  return (
    <Button
      onClick={onClick}
      size={'small'}
      variant={'ghost'}
      style={{
        textTransform: 'none',
        background: 'rgba(0, 109, 179, 0.06)',
        fontWeight: Tokens.text.weight.bold,
        padding: '10px',
      }}
    >
      <IconWrapper>
        <NavigationIcon name="add" active={true} />
      </IconWrapper>
    </Button>
  );
};
